import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class CommitAction extends BaseOption {
  static userInterfaceComponent = {
    label: "Save on blur action",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "";
}
